import { useState, useEffect } from 'react';
import { API_BASE as API_URL, getToken} from '../../../lib/api';


export function SolutionSelector({ currentSolutionId, isDirty, onSelect }) {
  const [solutions, setSolutions] = useState([]);

  useEffect(() => {
    const token = getToken() || sessionStorage.getItem('retailcliq_token') || localStorage.getItem('erp_token') || '';
    fetch(`${API_URL}/api/attribute-engine/config/solutions`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => res.json())
      .then(res => { if (res.success) setSolutions(res.data); })
      .catch(() => {});
  }, []);

  return (
    <div className="sel-wrap">
      <label className="sel-lbl" htmlFor="sol-sel">Industry</label>
      <select id="sol-sel" value={currentSolutionId} className="sel-ctrl"
        onChange={e => {
          const id = e.target.value;
          if (id === currentSolutionId) return;
          if (isDirty && !window.confirm('Unsaved changes will be drafted. Switch solution?')) {
            e.target.value = currentSolutionId;
            return;
          }
          onSelect(id);
        }}>
        {solutions.map(s => <option key={s.id} value={s.id}>{s.icon} {s.label}</option>)}
      </select>
    </div>
  );
}
